import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";
import { formatCurrency } from "@theme/utilities";

class ProgressBar extends HTMLElement {
  static get observedAttributes() { return ["percent"]; }
  connectedCallback() { this.updateDisplay(); }
  attributeChangedCallback() { this.updateDisplay(); }
  updateDisplay() {
    const percent = Math.min(Math.max(Number(this.getAttribute("percent")) || 0, 0), 100);
    this.querySelector(".progress-bar__fill")?.style.setProperty("--percent", `${percent}%`);
  }
}

export class FreeShippingGoal extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);
    document.addEventListener(ThemeEvents.cartUpdated, this.handleCartUpdated);
    document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
    this.updateDisplay();
  }
  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);
    document.removeEventListener(ThemeEvents.cartUpdated, this.handleCartUpdated);
    document.removeEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
    super.disconnectedCallback();
  }
  handleDiscountUpdate = (event) => {
    const cart = event.detail?.resource;
    if (!cart || !Number.isFinite(Number(cart.total_price))) return;
    this.dataset.cartTotal = cart.total_price;
    this.dataset.currentCurrency = cart.currency || this.dataset.currentCurrency;
    this.updateDisplay();
  };
  handleCartUpdated = (event) => {
    const cart = event.detail?.cart;
    if (!cart || !Number.isFinite(Number(cart.total_price))) return;
    this.dataset.cartTotal = cart.total_price;
    this.dataset.currentCurrency = cart.currency || this.dataset.currentCurrency;
    this.updateDisplay();
  };
  handleCartUpdate = (event) => {
    const sectionId = this.closest("[data-section-id]")?.dataset.sectionId;
    const markup = sectionId && event.detail?.data?.sections?.[sectionId];
    if (markup) {
      const fresh = new DOMParser().parseFromString(markup, "text/html").querySelector("free-shipping-goal");
      if (fresh?.dataset.cartTotal) {
        this.dataset.cartTotal = fresh.dataset.cartTotal;
        this.updateDisplay();
        return;
      }
    }
    fetch(`${window.FoxTheme?.routes?.cart_url || "/cart"}.js`)
      .then((response) => response.ok ? response.json() : Promise.reject(response))
      .then((cart) => {
        this.dataset.cartTotal = cart.total_price;
        this.dataset.currentCurrency = cart.currency || this.dataset.currentCurrency;
        this.updateDisplay();
      }).catch(() => {});
  };
  get rate() {
    if (this.dataset.currentCurrency === this.dataset.shopCurrency) return 1;
    const rate = Number(window.Shopify?.currency?.rate);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  }
  get tiers() {
    return (this.dataset.tiers || "").split(",").map((entry) => {
      const [amount, discount] = entry.trim().split(":").map(Number);
      return { amount: Math.round(amount * this.rate * 100), discount };
    }).filter((tier) => tier.amount > 0 && Number.isFinite(tier.discount))
      .sort((a, b) => a.amount - b.amount);
  }
  updateDisplay() {
    const total = Math.max(Number(this.dataset.cartTotal) || 0, 0);
    const tiers = this.tiers;
    if (!tiers.length) return;
    const achieved = [...tiers].reverse().find((tier) => total >= tier.amount);
    const next = tiers.find((tier) => total < tier.amount);
    const maximum = tiers[tiers.length - 1];
    const message = this.querySelector(".shipping-tiers__message-text");
    const moneyFormat = window.FoxTheme?.moneyFormat || window.Shopify?.currency?.money_format;
    if (!next) {
      message.textContent = maximum.discount === 100 ? "Skvělé, dopravu máte zdarma." : `Máte ${maximum.discount}% slevu na dopravu.`;
    } else {
      const remaining = formatCurrency(next.amount - total, moneyFormat);
      const benefit = next.discount === 100 ? "dopravu zdarma" : `slevu ${next.discount} % na dopravu`;
      message.textContent = achieved ? `Máte ${achieved.discount}% slevu na dopravu. Přidejte ještě ${remaining} a získáte ${benefit}.` : `Přidejte ještě ${remaining} a získáte ${benefit}.`;
    }
    this.querySelector("progress-bar")?.setAttribute("percent", String(Math.min(total / maximum.amount * 100, 100)));
    this.querySelectorAll("[data-shipping-amount]").forEach((step) => {
      const stepAmount = Math.round(Number(step.dataset.shippingAmount) * this.rate * 100);
      const tier = tiers.find((item) => item.amount === stepAmount);
      step.classList.toggle("is-achieved", Boolean(tier && total >= tier.amount));
      step.classList.toggle("is-next", tier === next);
    });
  }
}
if (!customElements.get("progress-bar")) customElements.define("progress-bar", ProgressBar);
if (!customElements.get("free-shipping-goal")) customElements.define("free-shipping-goal", FreeShippingGoal);
